import {
  PresentationComponentProps,
  checkGroupVisibility,
  evaluateWithContext
} from "../../../index";
import Typography from "@material-ui/core/Typography";
import React, { useMemo, Fragment } from "react";
import { FlatForm } from "./FlatForm";
import { Divider, Theme } from "@material-ui/core";
import makeStyles from "@material-ui/styles/makeStyles";
import { createStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    divider: {
      marginBottom: theme.spacing(3)
    },
    groupTitle: {
      marginBottom: theme.spacing(3)
    }
  })
);

export const FieldSetsForm = (props: PresentationComponentProps) => {
  const groups = useMemo(() => props.schema.partitionByGroup(), [props.schema]);
  const classes = useStyles();
  return (
    <>
      {Object.entries(groups).map(([groupName, schema], index) => {
        if (checkGroupVisibility(schema, props.data)) {
          return (
            <div key={groupName}>
              {index > 0 ? <Divider className={classes.divider} /> : null}
              <Typography variant={"h6"} className={classes.groupTitle}>
                {evaluateWithContext({}, props.schema.groups[groupName]) ||
                  groupName}
              </Typography>
              <FlatForm
                fieldMapper={props.fieldMapper}
                schema={schema}
                data={props.data}
              />
            </div>
          );
        } else {
          return <Fragment key={groupName} />;
        }
      })}
    </>
  );
};
